export default "__VITE_ASSET__Bnl$RQRe__"